export default __webpack_public_path__ + "b2a16d5c5634c90a860e34c8682719fd.png";